import { Link } from 'react-router-dom';
import { navigationLinks, siteInfo } from '@/mocks/navigation';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-vip-crown-2-line text-lg text-background-50"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                  {siteInfo.name}
                </span>
              </Link>
              <p className="text-sm text-background-50/60 leading-relaxed">
                {siteInfo.description}
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                {navigationLinks.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门游戏</h4>
              <ul className="space-y-2.5">
                <li><span className="text-sm text-background-50/60 cursor-pointer hover:text-primary-400 transition-colors duration-200">百家乐</span></li>
                <li><span className="text-sm text-background-50/60 cursor-pointer hover:text-primary-400 transition-colors duration-200">老虎机</span></li>
                <li><span className="text-sm text-background-50/60 cursor-pointer hover:text-primary-400 transition-colors duration-200">德州扑克</span></li>
                <li><span className="text-sm text-background-50/60 cursor-pointer hover:text-primary-400 transition-colors duration-200">真人视讯</span></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-sm text-primary-400 mt-0.5 shrink-0"></i>
                  <span className="text-sm text-background-50/60">{siteInfo.phone}</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-sm text-primary-400 mt-0.5 shrink-0"></i>
                  <span className="text-sm text-background-50/60">{siteInfo.email}</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-sm text-primary-400 mt-0.5 shrink-0"></i>
                  <span className="text-sm text-background-50/60">{siteInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              {siteInfo.copyright.replace('2026', String(currentYear))}
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-50/40 cursor-pointer hover:text-primary-400 transition-colors duration-200">隐私政策</span>
              <span className="text-xs text-background-50/40 cursor-pointer hover:text-primary-400 transition-colors duration-200">服务条款</span>
              <span className="text-xs text-background-50/40 cursor-pointer hover:text-primary-400 transition-colors duration-200">负责任博彩</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}